import { useApiQuery } from './useApiQuery';

interface PartnerAnalytics {
  totalLeads: number;
  registeredLeads: number;
  unregisteredLeads: number;
  remindersSet: number;
}

interface PartnerAnalyticsResponse {
  success: boolean;
  message: string;
  data: {
    analytics: PartnerAnalytics;
  };
}

export function usePartnerAnalytics() {
  return useApiQuery<PartnerAnalyticsResponse>({
    queryKey: ['partner-analytics'],
    request: {
      method: 'GET',
      url: '/analytics/partner',
    },
  });
}
